<mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>
<mat-dialog-actions class="justify-content-end mt-4">
    <button type="button" mat-raised-button color="primary" (click)="closeDialogue(true)">{{data.ok}}</button>
</mat-dialog-actions>